// Shared catalogue for company setup and equipment editing.
// Existing stored values remain compatible; temperature limits are configured separately.
export const EQUIPMENT_TYPE_GROUPS = [
  { label: "Refrigerazione e conservazione", options: [
    ["frigorifero", "Frigorifero"],
    ["armadio_refrigerato", "Armadio refrigerato"],
    ["cella_frigorifera", "Cella frigorifera positiva"],
    ["tavolo_refrigerato", "Tavolo refrigerato"],
    ["banco_refrigerato", "Banco refrigerato"],
    ["vetrina", "Vetrina refrigerata"],
    ["espositore_refrigerato", "Espositore refrigerato verticale"],
    ["saladette", "Saladette / banco ingredienti"],
    ["frigorifero_bevande", "Frigorifero per bevande"],
    ["frigorifero_pesce", "Frigorifero per pesce"],
    ["armadio_frollatura", "Armadio di frollatura"],
    ["cella_stagionatura", "Cella di stagionatura"],
  ] },
  { label: "Congelamento e abbattimento", options: [
    ["congelatore", "Congelatore"],
    ["congelatore_pozzetto", "Congelatore a pozzetto"],
    ["armadio_congelatore", "Armadio congelatore"],
    ["cella_congelamento", "Cella frigorifera negativa"],
    ["banco_surgelati", "Banco espositore surgelati"],
    ["abbattitore", "Abbattitore di temperatura"],
    ["abbattitore_surgelatore", "Abbattitore / surgelatore"],
    ["fabbricatore_ghiaccio", "Fabbricatore di ghiaccio"],
  ] },
  { label: "Cottura e mantenimento caldo", options: [
    ["forno_convezione", "Forno a convezione"],
    ["forno_combinato", "Forno combinato / a vapore"],
    ["forno_statico", "Forno statico"],
    ["forno_pizza", "Forno per pizza"],
    ["forno_microonde", "Forno a microonde"],
    ["cucina_gas", "Cucina a gas"],
    ["piano_induzione", "Piano a induzione"],
    ["friggitrice", "Friggitrice"],
    ["piastra_cottura", "Piastra di cottura / fry top"],
    ["griglia", "Griglia / barbecue"],
    ["girarrosto", "Girarrosto"],
    ["cuocipasta", "Cuocipasta"],
    ["brasiera", "Brasiera"],
    ["pentola_cottura", "Pentola di cottura professionale"],
    ["roner", "Roner / bagno termostatico"],
    ["bagnomaria", "Bagnomaria"],
    ["armadio_caldo", "Armadio caldo / scaldavivande"],
    ["vetrina_calda", "Vetrina calda"],
    ["carrello_termico", "Carrello termico portavivande"],
  ] },
  { label: "Preparazione e lavorazione", options: [
    ["affettatrice", "Affettatrice"],
    ["tritacarne", "Tritacarne"],
    ["segaossa", "Segaossa"],
    ["insaccatrice", "Insaccatrice"],
    ["hamburgatrice", "Hamburgatrice"],
    ["cutter", "Cutter / robot da cucina"],
    ["frullatore", "Frullatore / mixer"],
    ["tagliaverdure", "Tagliaverdure"],
    ["pelapatate", "Pelapatate"],
    ["grattugia", "Grattugia professionale"],
    ["impastatrice", "Impastatrice"],
    ["planetaria", "Planetaria"],
    ["sfogliatrice", "Sfogliatrice / laminatoio"],
    ["tirapasta", "Tirapasta / macchina per pasta fresca"],
    ["banco_lavoro", "Banco di lavoro"],
    ["bilancia", "Bilancia"],
  ] },
  { label: "Panificazione, pasticceria e gelateria", options: [
    ["cella_lievitazione", "Cella di lievitazione"],
    ["fermalievitazione", "Armadio / cella di fermalievitazione"],
    ["spezzatrice", "Spezzatrice / arrotondatrice"],
    ["temperatrice", "Temperatrice per cioccolato"],
    ["pastorizzatore", "Pastorizzatore"],
    ["mantecatore", "Mantecatore per gelato"],
    ["vetrina_gelato", "Vetrina per gelato"],
    ["pozzetti_gelato", "Banco a pozzetti per gelato"],
  ] },
  { label: "Confezionamento e trasporto", options: [
    ["sottovuoto", "Confezionatrice sottovuoto"],
    ["termosigillatrice", "Termosigillatrice"],
    ["confezionatrice_atm", "Confezionatrice in atmosfera modificata"],
    ["etichettatrice", "Etichettatrice"],
    ["contenitore_isotermico", "Contenitore isotermico"],
    ["veicolo_refrigerato", "Veicolo refrigerato"],
  ] },
  { label: "Lavaggio e igiene", options: [
    ["lavastoviglie", "Lavastoviglie professionale"],
    ["lavabicchieri", "Lavabicchieri"],
    ["lavapentole", "Lavapentole"],
    ["lavello", "Lavello / vasca di lavaggio"],
    ["lavamani", "Lavamani"],
    ["sterilizzatore_coltelli", "Sterilizzatore per coltelli"],
    ["cappa_aspirante", "Cappa aspirante"],
  ] },
  { label: "Bar e somministrazione", options: [
    ["macchina_caffe", "Macchina da caffè"],
    ["macinacaffe", "Macinacaffè"],
    ["spremiagrumi", "Spremiagrumi"],
    ["estrattore", "Estrattore / centrifuga"],
    ["granitori", "Granitore"],
    ["erogatore_bevande", "Erogatore di bevande"],
    ["spillatore", "Spillatore"],
  ] },
  // Strumenti di misura: non sono a temperatura controllata (non entrano nel
  // registro temperature), servono per sonda al cuore e controllo olio.
  { label: "Strumenti di misura", options: [
    ["sonda_termometrica", "Sonda termometrica al cuore"],
    ["termometro_olio", "Termometro per olio di frittura"],
    ["tester_polari", "Tester composti polari dell’olio"],
  ] },
  { label: "Altro", options: [["altro", "Altra attrezzatura (specificare nel nome)"]] },
];
export const EQUIPMENT_TYPE_OPTIONS = EQUIPMENT_TYPE_GROUPS.flatMap((group) => group.options);

const THERMAL_TYPES = new Set([
  ...EQUIPMENT_TYPE_GROUPS.slice(0, 2).flatMap((group) => group.options.map(([id]) => id)),
  "forno_convezione", "forno_combinato", "forno_statico", "forno_pizza", "friggitrice", "roner", "bagnomaria", "armadio_caldo", "vetrina_calda", "carrello_termico",
  "cella_lievitazione", "fermalievitazione", "pastorizzatore", "mantecatore", "vetrina_gelato", "pozzetti_gelato", "veicolo_refrigerato",
]);
export const THERMAL_EQUIPMENT_GROUPS = EQUIPMENT_TYPE_GROUPS.map((group) => ({ ...group, options: group.options.filter(([id]) => THERMAL_TYPES.has(id) || id === "altro") })).filter((group) => group.options.length);
export const BUSINESS_EQUIPMENT_GROUPS = EQUIPMENT_TYPE_GROUPS.map((group) => ({ ...group, options: group.options.filter(([id]) => !THERMAL_TYPES.has(id)) })).filter((group) => group.options.length);
export const isTemperatureControlled = (equipment) => equipment.temperature_controlled ?? (equipment.temp_range?.min != null || equipment.temp_range?.max != null);

export function buildBusinessEquipmentJobs(selection, siteId, departmentId, equipment, makeId) {
  const names = new Set(equipment.filter((item) => item.site_id === siteId && (item.department_id || "") === departmentId).map((item) => item.name));
  return selection.flatMap(({ type, label, quantity }) => {
    const jobs = [];
    let number = 1;
    for (let i = 0; i < quantity; i += 1) {
      while (names.has(`${label} ${number}`)) number += 1;
      const name = `${label} ${number++}`;
      names.add(name);
      jobs.push({ site_id: siteId, department_id: departmentId || null, name, type, temperature_controlled: false, temp_min: null, temp_max: null, request_id: makeId() });
    }
    return jobs;
  });
}
